import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid, 
  LinearProgress,
  Typography,
  makeStyles,
  colors,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemIcon,
  Divider,
  Button,
  Slider
} from '@material-ui/core';
import HealingIcon from '@material-ui/icons/Healing';
import ControlPointIcon from '@material-ui/icons/ControlPoint';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import DiscreteSliderAdmin from '../treatmentSession/rehabPhaseProgressBar_symptomTracker_assessment';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: '#002D55',
    height: 50,
    width: 50
  },
  differenceIcon: {
    color: colors.red[900]
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1)
  }
}));


const Yourdiagnosis = (props) => {
  const classes = useStyles();
  const className = props.className;
  // Approve/Change diagnosis state
  const [approveState, setApproveState] = React.useState(null);
  const [diagnosisSelect, setDiagnosisSelect] = React.useState("");
  const [diagnosisInput, setDiagnosisInput] = React.useState("");
  const [editedDiagnosis, setEditedDiagnosis] = React.useState("");

  const [subGoals, setSubGoals] = React.useState([
    "Limited rotation the left",
    "Difficulty looking upwards and backwards",
    "Neck discomfort and pain when laying on the side",
    
  ]);
  const [subGoalValues, setSubGoalValues] = React.useState([0, 0, 0]);
  const [symptoms, setSymptoms] = React.useState([
    "Stiffness or tension in neck",
    "Retraction exercises, both alone and combined with extension, result in symptom improvement."
    
  ]);
  const [flags, setFlags] = React.useState([
    "No red flags identified.",
    
  ]);

  const [Rx, setRx] = React.useState([
    "Virtual physiotherapy self-management trial for 2 weeks. ",
    "Refer for in-person assessment if no improvement or worsening of symptoms."
    
  ]);

  const [symptomValues, setSymptomValues] = React.useState([0, 0, 0]);
  const [newSubGoal, setNewSubGoal] = React.useState("");
  const [newSymptom, setNewSymptom] = React.useState("");
  const [celebrateOpen, setCelebrateOpen] = React.useState(false);
  const [celebrateMsg, setCelebrateMsg] = React.useState("");
    
  const handleSubGoalChange = (idx, val) => {
    const newVals = [...subGoalValues];
    newVals[idx] = val;
    setSubGoalValues(newVals);
    localStorage.setItem('subGoalValues', JSON.stringify(newVals));
    if (val === 100) {
      setCelebrateMsg(`Sub-goal achieved: ${subGoals[idx]}! 🎉`);
      setCelebrateOpen(true);
    }
  };

  const handleSymptomChange = (idx, val) => {
    const newVals = [...symptomValues];
    newVals[idx] = val;
    setSymptomValues(newVals);
    localStorage.setItem('symptomValues', JSON.stringify(newVals));
    if (val === 100) {
      setCelebrateMsg(`Symptom improvement: ${symptoms[idx]}! 🎉`);
      setCelebrateOpen(true);
    }
  };

  const handleAddSubGoal = () => {
    if (newSubGoal.trim()) {
      setSubGoals([...subGoals, newSubGoal.trim()]);
      setSubGoalValues([...subGoalValues, 0]);
      setNewSubGoal("");
    }
  };

  const handleAddSymptom = () => {
    if (newSymptom.trim()) {
      setSymptoms([...symptoms, newSymptom.trim()]);
      setSymptomValues([...symptomValues, 0]);
      setNewSymptom("");
    }
  };

  React.useEffect(() => {
      const savedSubGoals = localStorage.getItem('subGoalValues');
      const savedSymptoms = localStorage.getItem('symptomValues');
      if (savedSubGoals) setSubGoalValues(JSON.parse(savedSubGoals));
      if (savedSymptoms) setSymptomValues(JSON.parse(savedSymptoms));
    }, []);

  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
        >
          <Grid item xs={1} style={{marginRight: 30}}>
            <Avatar className={classes.avatar}><HealingIcon /></Avatar>
          </Grid>
          <Grid item xs={10}>
            <Typography
              style={{color: "#002D55", marginBottom: 5, marginTop: 6, marginLeft: -2}}
              variant="h4"
            >
              Summary of assessment:
            </Typography>
            <Typography variant="body1" style={{ width: '100%' }} >
              The patient has not been examined by a medical doctor prior to this consultation. Symptoms began gradually without any traumatic incident and have persisted over time at a moderate intensity. The pain is located in the cervical region, with no specific side identified, and has occurred in multiple episodes without notable change in pattern since onset. The patient reports neck stiffness without accompanying headaches or migraines, and no neurological warning signs. No other significant symptoms are present.
              <br /><br /> On physical self-assessment, there is no sharp pain radiating to the arms or fingers during rotation or tilt, nor any sudden loss of strength, numbness, tingling, or burning sensations in the upper limbs. Provocative tests for nerve involvement, including Valsalva’s maneuver and arm-over-head relief, were negative. Neck flexion to the chest is within normal limits and forward bending is pain-free. However, neck extension is limited, and rotation to either side is somewhat restricted with discomfort. Retraction exercises, both alone and combined with extension, result in symptom improvement.
            </Typography>
            <Box mt={2} mb={2}>
            </Box>
            {/* Move recommended approach card to share row with Red Flag Screening below */}
              <Box p={0} display="flex" flexDirection="column" alignItems="flex-start">
                    
                    <Box mt={0} mb={0} xs={11} style={{marginLeft: 0, paddingLeft: 0, marginTop: 10}}>
                      <Box width={{ xs: '100%', marginBottom: 16 }} px={0}>
                          
                          
                        </Box>
                      <Box display="flex" flexWrap="wrap" width="100%" justifyContent="center" style={{marginLeft: 0, paddingLeft: 0}}>
                        <Card elevation={2} style={{ padding: 10, flex: '1 1 220px', marginRight: 18, marginBottom: 8, background: '#f5faff', borderRadius: 12, boxShadow: '0 1px 8px rgba(0,45,85,0.07)', padding: 16 }}>
                          <Box width='100%' px={0}>
                            <span style={{ fontWeight: 'bold', color: "#002D55", fontSize: 'clamp(15px, 1.3vw, 20px)', marginLeft: 0, marginBottom: 8, display: 'block' }}>
                              Key symptoms:
                            </span>
                            {symptoms.map((symptom, idx) => (
                              <Box key={symptom} display="flex" alignItems="center" mb={1}>
                                <Box mr={2}>
                                  -
                                </Box>
                                <span style={{ color: '#e53935', fontSize: 'clamp(11px, 0.9vw, 15px)', paddingRight: 20 }}>{symptom}</span>
                              </Box>
                            ))}
                            <Box display="flex" flexDirection="row" alignItems="flex-end" mt={3} mb={1} justifyContent="flex-end">
                              {/* Add controls or actions here if needed */}
                            </Box>
                          </Box>
                        </Card>
                        <Card elevation={2} style={{ padding: 10, flex: '1 1 220px', marginRight: 18, marginBottom: 8, background: '#f5faff', borderRadius: 12, boxShadow: '0 1px 8px rgba(0,45,85,0.07)', padding: 16 }}>
                          <Box width='100%' px={0}>
                            <span style={{ fontWeight: 'bold', color: "#002D55", fontSize: 'clamp(15px, 1.3vw, 20px)', marginLeft: 0, marginBottom: 8, display: 'block' }}>
                              Noted functional limitations:
                            </span>
                            {subGoals.map((goal, idx) => (
                              <Box key={goal} display="flex" alignItems="center" mb={1}>
                                <Box mr={2}>
                                  -
                                </Box>
                                <span style={{ color: '#002D55', fontSize: 'clamp(11px, 0.9vw, 15px)' }}>{goal}</span>
                              </Box>
                            ))}
                            <Box display="flex" flexDirection="row" alignItems="flex-end" mt={3} mb={1} justifyContent="flex-end">
                              {/* Add controls or actions here if needed */}
                            </Box>
                          </Box>
                        </Card>
                      </Box>
                    </Box>
                    <Box mt={0} mb={0} xs={11} style={{marginLeft: 0, paddingLeft: 0, marginTop: 10}}>
                      <Box width={{ xs: '100%', marginBottom: 16 }} px={0}>
                        {/* ...existing code... */}
                      </Box>
                      <Grid container xs={12} display="flex" flexWrap="wrap" width="100%" justifyContent="center" style={{marginLeft: 0, paddingLeft: 0}}>
                        <Card xs={6} elevation={2} style={{ padding: 10, marginRight: 18, marginBottom: 8, background: '#f5faff', borderRadius: 12, boxShadow: '0 1px 8px rgba(0,45,85,0.07)', padding: 16 }}>
                          <Box width='100%' px={0}>
                            <span style={{ fontWeight: 'bold', color: "#002D55", fontSize: 'clamp(15px, 1.3vw, 20px)', marginLeft: 0, marginBottom: 8, display: 'block' }}>
                              Red Flag Screening:
                            </span>
                            {flags.map((flag, idx) => (
                              <Box key={flag} display="flex" alignItems="center" mb={1}>
                                <Box mr={2}>
                                  -
                                </Box>
                                <span style={{ color: '#e53935', fontSize: 'clamp(11px, 0.9vw, 15px)', paddingRight: 20 }}>{flag}</span>
                              </Box>
                            ))}
                            <Box display="flex" flexDirection="row" alignItems="flex-end" mt={3} mb={1} justifyContent="flex-end">
                              {/* Add controls or actions here if needed */}
                            </Box>
                          </Box>
                        </Card>
                      </Grid>
                    </Box>
                </Box>
             <Typography>
              <span style={{marginTop: 40, marginBottom: 0, display: 'inline-block'}}>
                Based on your answers, our evaluation suggests the best explanation of your reported symptoms are:
              </span> <br /><br />
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="flex-start" style={{marginTop: -5, marginBottom: 5, marginLeft: -2}}>
              <Typography style={{color: "#002D55"}} variant="h5">
                {editedDiagnosis
                  ? <>Edited diagnosis: {editedDiagnosis}</>
                  : <>Suggested diagnosis: {props.title}</>
                }
              </Typography>
              <Box ml={3} display="flex" alignItems="center">
                <Button
                  variant="contained"
                  style={{
                    background: approveState === 'approved' ? '#00b894' : 'rgba(0,0,0,0.54)',
                    color: '#fff',
                    marginRight: 10,
                    fontWeight: 600,
                    textTransform: 'none',
                    boxShadow: 'none'
                  }}
                  onClick={() => setApproveState('approved')}
                >
                  {approveState === 'approved' ? 'Approved' : 'Approve'}
                </Button>
                <Button
                  variant="outlined"
                  style={{ borderColor: '#e67e22', color: '#e67e22', fontWeight: 600, textTransform: 'none', boxShadow: 'none' }}
                  onClick={() => setApproveState('change')}
                >
                  Change
                </Button>
              </Box>
            </Box>
            {approveState === 'change' && (
              <Box display="flex" alignItems="center" mt={2} mb={2}>
                <Typography style={{marginRight: 10, color: '#002D55', fontWeight: 500}}>
                  Select or type a new diagnosis:
                </Typography>
                <select
                  style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #002D55', color: '#002D55', marginRight: 10 }}
                  value={diagnosisSelect}
                  onChange={e => setDiagnosisSelect(e.target.value)}
                >
                  <option value="">-- Select --</option>
                  <option value="Cervical Radiculopathy">Cervical Radiculopathy</option>
                  <option value="Cervicogenic Headache">Cervicogenic Headache</option>
                  <option value="Neck Strain">Neck Strain</option>
                  <option value="Other">Other (type below)</option>
                </select>
                <input
                  type="text"
                  placeholder="Type diagnosis..."
                  style={{ padding: '6px 12px', borderRadius: 6, border: '1px solid #002D55', color: '#002D55', minWidth: 180 }}
                  value={diagnosisInput}
                  onChange={e => setDiagnosisInput(e.target.value)}
                  disabled={diagnosisSelect !== 'Other'}
                />
                <Button
                  variant="contained"
                  style={{ background: '#002D55', color: '#fff', marginLeft: 10, fontWeight: 600, textTransform: 'none', boxShadow: 'none' }}
                  onClick={() => {
                    // Save or handle the new diagnosis here
                    let newDiag = diagnosisSelect === 'Other' ? diagnosisInput : diagnosisSelect;
                    if (newDiag) setEditedDiagnosis(newDiag);
                    setApproveState('approved');
                  }}
                >
                  Confirm
                </Button>
              </Box>
            )}

            <Typography style={{marginBottom: 15}} variant="body1" color="textSecondary">
              {props.explainer}
            </Typography>
            <Box width="100%" display="flex" justifyContent="flex-start" mt={2} mb={2}>
              <Card elevation={2} style={{
                width: '100%',
                maxWidth: 600,
                background: '#eaeaf4',
                borderRadius: 14,
                boxShadow: '0 2px 12px rgba(0,45,85,0.08)',
                padding: 24,
                marginLeft: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}>
                <Typography variant="h5" style={{ fontWeight: 700, color: '#002D55', marginBottom: 12, letterSpacing: 0.2 }}>
                  Recommended approach
                </Typography>
                {Rx.map((rx, idx) => (
                  <Box key={rx} display="flex" alignItems="center" mb={1}>
                    <Box mr={2} style={{ fontWeight: 700, color: '#002D55' }}>•</Box>
                    <Typography variant="body1" style={{ color: '#002D55', fontSize: 'clamp(12px, 1vw, 16px)', paddingRight: 20 }}>
                      {rx}
                    </Typography>
                  </Box>
                ))}
              </Card>
            </Box>
            <Box
          mt={2}
          display="flex"
          alignItems="center"   
        >
        <Grid container direction="column" style={{marginRight: 40}}>
            <Grid item alignItems="left">
                
            </Grid>
          </Grid>
        </Box>
          </Grid>
        </Grid>
        
                  
      </CardContent>
    </Card>
  );
};

Yourdiagnosis.propTypes = {
  className: PropTypes.string
};

export default Yourdiagnosis;